import { observable, action } from 'mobx';

class UrlHistoryTrackerStore {
  @observable previousURL = null;

  @observable currentURL = null;

  @observable referrerURL = null;

  @action
  setUrlHistory() {
    this.referrerURL = document.referrer;
    if (this.currentURL !== window.parent.location.href) {
      this.previousURL = this.currentURL;
    }
    this.currentURL = window.parent.location.href;
  }
}

export default new UrlHistoryTrackerStore();



// WEBPACK FOOTER //
// ./src/stores/UrlHistoryTracker.store.js